import * as React from 'react';
import { IS_KOALA } from '../../utils/config';

export const LeftPart = () => {
    const currentYear = new Date().getFullYear();
    const companyName = IS_KOALA ? 'Koala Games' : 'RubyPlay';

    return (
        <div
            className="relative hidden min-h-screen overflow-hidden lg:flex lg:w-1/2 lg:flex-col lg:items-center lg:justify-center"
            style={{
                backgroundColor: 'var(--accent-color)',
                backgroundImage:
                    'linear-gradient(180deg, rgba(10, 15, 33, 0.18), rgba(10, 15, 33, 0.52)), var(--background-image)',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
            }}
        >
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.14),transparent_35%)]" />
            <div
                className="relative z-10 h-[21rem] w-[14.5rem] bg-contain bg-center bg-no-repeat drop-shadow-[0_28px_48px_rgba(0,0,0,0.24)]"
                style={{ backgroundImage: 'var(--login-logo)' }}
            />
            <div className="absolute bottom-8 z-10 text-sm tracking-[0.02em] text-white/80 [font-family:futura-pt,sans-serif]">
                © 2017-{currentYear} {companyName}
            </div>
        </div>
    );
};
